import { createBlock } from 'factories/block';
import { repeat } from './interaction';
import { createLayout } from 'factories/layout';
import contentCard_default from 'assets/Card_Test.png';
import { colors } from 'styles/variables';
import { createMediaBlock } from './media';
import { Block, cloneBlock, Blocks } from 'factories/block';
import { flatten } from 'factories/utils';
import { createContinueBtn } from './continueBtn';
import { getSId } from '../utils';
import { getPlaceholderText } from './text';

const { lPink, lGrey0, lGrey2, lTeal0 } = colors;

const createContentCardBlock = props => {
  return createBlock('ContentCard', [
    createMediaBlock({
      src: undefined,
      child: 1,
      fit: 'cover',
      useBackgroundControls: false,
    }),
    createBlock('Text', [], {
      props: {
        useBackgroundControls: true,
        content: 'Example text content',
        className: 'text-align-center',
      },
    }),
    createContinueBtn({
      label: 'Add navigation',
      removeable: false,
      disableLastPageMessage: true,
    }),
  ]);
};

export const createContentCardsBlock = (count: number) => {
  return createBlock('ContentCards', [
    ...repeat(() => createContentCardBlock({}), count),
  ]);
};

export const addContentCard = (
  block: Block,
  position: number
): [Block, Blocks?] => {
  if (block.type === 'ContentCards') {
    const contentCardBlock = createContentCardBlock({});

    const contentCardBlockRef = { id: contentCardBlock.id, type: 'Ref' };
    const [newBlocks] = flatten(contentCardBlock);

    const nextBlock = cloneBlock(block);
    (nextBlock.children as Block[]).splice(position, 0, contentCardBlockRef);

    return [nextBlock, newBlocks];
  }
  return [block, undefined];
};

export const removeContentCard = (
  block: Block,
  position: number
): [Block, Blocks?] => {
  if (block.type === 'ContentCards') {
    const contentCardBlock = createContentCardBlock({});

    const [newBlocks] = flatten(contentCardBlock);

    const nextBlock = cloneBlock(block);
    (nextBlock.children as Block[]).splice(position, 1);

    return [nextBlock, newBlocks];
  }
  return [block, undefined];
};

const contentForColumn = (count: number) => (i: number) => {
  return [
    () =>
      createMediaBlock({
        child: 0,
        textPlaceholderContent: getPlaceholderText('h1', 'heading-one'),
        className: 'cards media-0',
      }),
    () =>
      createBlock('InteractionColumn', [
        createContentCardsBlock(count),
        createMediaBlock({
          child: 0,
          isAdditionalMedia: true,
        }),
      ]),
  ][i];
};

export const createContentCardInteractionBlock = props => {
  //
  const {
    grid = 'masonry',
    contentCardBackgroundColor = '#fff',
    contentCardPanelTextColor = lGrey0,
    contentCardContentTextColor = lGrey0,
    width = 33,
    height = 0,
    borderRadius = 20,
    outline = false,
    borderColor = lGrey0,
    imagePosition = 'top',
    includeText = true,
    includeShadow = true,
    uniformHeight = false,
    numColumns = 3,
    style,
  } = props as any;

  return createBlock(
    'Interaction',
    [
      createLayout(contentForColumn(props.numberOfCards), 0, true),

      createBlock('SingleColumnLayout', [
        createBlock('Column', [createContinueBtn(style)], {
          props: {
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'center',
            flexWrap: 'wrap',
          },
          meta: {
            subType: 'ButtonBlock',
          },
        }),
      ]),
    ],
    {
      props: {
        name: props.name,
        sId: getSId('interaction'),
        style: props.style,
        grid,
        contentCardBackgroundColor,
        contentCardPanelTextColor,
        contentCardContentTextColor,
        width,
        height,
        outline,
        borderRadius,
        borderColor,
        imagePosition,
        includeText,
        includeShadow,
        uniformHeight,
        numColumns,
      },
      meta: {
        subType: 'ContentCards',

        layout: 'OneColumn',
      },
    }
  );
};

export const create = createContentCardInteractionBlock;
export const interactionConfig = {};

export { contentCard_default };
